import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import Select from 'react-select'
import Header from 'components/Layout/New/Header'
import Form from './Form'
import {
  saveWelcome,
  welcomeTypeChange,
  clearWelcomeState,
  fetchWelcomes,
  loadWelcome,
} from 'actions'
import { MESSAGE_DESTINATION_OPTIONS } from 'config/constants'

const welcomeCTAs = MESSAGE_DESTINATION_OPTIONS.filter(
  option => !option.onlyMessage,
)

class NewWelcome extends Component {
  componentDidMount = async () => {
    const {
      location,
      match: { params },
    } = this.props
    if (location.pathname.includes('edit') && params && params.welcomeId) {
      await this.props.fetchWelcomes()
      this.props.loadWelcome(params.welcomeId)
    }
  }

  componentWillUnmount() {
    this.props.clearWelcomeState()
  }

  handleSave = async () => {
    const {
      location,
      match: { params },
    } = this.props
    if (location.pathname.includes('edit') && params && params.welcomeId) {
      await this.props.saveWelcome(params.welcomeId)
    } else {
      await this.props.saveWelcome()
    }
    this.props.history.push('/welcomes')
  }

  handleTypeChange = welcomeType => {
    this.props.welcomeTypeChange(welcomeType)
  }

  disableSave = () => {
    const { welcomeForm, welcomeType } = this.props
    if (welcomeForm && welcomeForm.values) {
      const { info, ctaText } = welcomeForm.values
      if (welcomeType.value === 'no_cta') {
        return !info
      } else {
        return !(info && ctaText)
      }
    }
    return true
  }

  render() {
    const { welcomeType } = this.props
    return (
      <div className="NewWelcome container">
        <Header
          headerTitle="New Welcome"
          handleSave={this.handleSave}
          showPreview={this.showPreview}
          parentRoute="/welcomes"
          disableSave={this.disableSave()}
        />

        <div className="row">
          <div className="col s4">
            <label>Welcome Type</label>
            <Select
              name="welcomeType"
              value={welcomeType.value}
              options={welcomeCTAs}
              searchable={false}
              clearable={false}
              onChange={this.handleTypeChange}
              disabled={false}
            />
          </div>
        </div>

        <Form />
      </div>
    )
  }
}

const mapStateToProps = state => {
  const {
    form: { welcomeForm },
    welcome: { currentWelcome, welcomeType, welcomeTypeDisabled },
  } = state

  return {
    welcomeForm,
    welcomeType,
    welcomeTypeDisabled,
    initialValues: currentWelcome,
  }
}

NewWelcome = reduxForm({
  form: 'welcomeForm',
})(NewWelcome)

NewWelcome = connect(
  mapStateToProps,
  {
    saveWelcome,
    welcomeTypeChange,
    clearWelcomeState,
    fetchWelcomes,
    loadWelcome,
  },
)(NewWelcome)

export default NewWelcome
